module.exports = __webpack_public_path__ + "static/media/OpeningBalance.870129f4.svg";